/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { Picture } from '../../types/Picture';

export default function getBiggestPictureUrl(picture: Picture) {
  const { formats } = picture;

  if (formats.medium) return formats.medium.url;
  if (formats.small) return formats.small.url;

  return formats.thumbnail.url;
}